import React, { useEffect, useRef } from "react";

import classes from "./Map.module.css";
let mapRef = null;

const Map = (props) => {
  let markers = [];

  const googleMapRef = useRef(null);

  //Create map script and add it to the head.
  function creatScript() {
    let googleMapScript = window.document.getElementById("google-scipt");
    if (googleMapScript === null) {
      googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
      googleMapScript.async = true;
      googleMapScript.id = "google-scipt";
      window.document.body.appendChild(googleMapScript);
      googleMapScript.addEventListener("load", () => {
        createGoogleMap();
      });
    } else {
      createGoogleMap();
    }
  }

  //handel errors of location access:
  function locationErrorHandler(err) {
    let coords = { lat: 3.130139984630583, lng: 101.71781613714228 };

    if (props.coords && props.coords.lat && props.coords.lng) {
      coords = { ...props.coords };
    }

    props.setCoordinate(coords);

    //Creat map:
    mapRef = new window.google.maps.Map(googleMapRef.current, {
      center: coords,
      zoom: 8,
    });

    // create infoWindow:
    let infoWindow = new window.google.maps.InfoWindow({
      content: "Clik to selcet your location",
      position: coords,
    });
    infoWindow.open(mapRef);

    mapRef.addListener("click", (mapsMouseEvent) => {
      infoWindow.close();
      markers.forEach((marker) => marker.setMap(null));
      props.setCoordinate(mapsMouseEvent.latLng.toJSON());
      creatMarker(mapRef, mapsMouseEvent.latLng);
    });

    mapRef.panTo(coords);
  }

  useEffect(creatScript, []);

  const createGoogleMap = () => {
    if (navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        (data) => {
          let coords = {
            lat: data.coords.latitude,
            lng: data.coords.longitude,
          };

          if (props.coords && props.coords.lat && props.coords.lng) {
            coords = { ...props.coords };
          }

          props.setCoordinate(coords);

          //Creat map:
          mapRef = new window.google.maps.Map(googleMapRef.current, {
            center: coords,
            zoom: 13,
          });

          //Create marker:
          creatMarker(mapRef, coords);

          //Create mrker:
          mapRef.addListener("click", (mapsMouseEvent) => {
            markers.forEach((marker) => marker.setMap(null));
            props.setCoordinate(mapsMouseEvent.latLng.toJSON());
            creatMarker(mapRef, mapsMouseEvent.latLng);
          });

          mapRef.panTo(coords);
        },
        (err) => {
          locationErrorHandler(err);
        }
      );
    } else {
      locationErrorHandler("Your borwser dosen't support this stuf!!");
    }
  };

  const creatMarker = (map, pos) => {
    const marker = new window.google.maps.Marker({
      position: pos,
      map: map,
    });
    map.panTo(pos);
    markers.push(marker);
  };

  return <div id="map" ref={googleMapRef} className={classes.Map} />;
};

export default Map;
